import React from 'react';
import StreamingAssessmentDisplay from '../StreamingAssessmentDisplay';

export interface StreamingPassage {
  number: number;
  title: string;
  content: string;
  genre?: string;
  isComplete: boolean;
}

export interface StreamingDisplayProps {
  passages: StreamingPassage[];
  questionsContent: string;
  answerKeyContent: string;
  status: string;
  isStreaming: boolean;
  isQuestionsComplete: boolean;
}

/** Wrapper for live assessment generation / modification streaming UI. */
const StreamingDisplay: React.FC<StreamingDisplayProps> = ({
  passages,
  questionsContent,
  answerKeyContent,
  status,
  isStreaming,
  isQuestionsComplete,
}) => (
  <StreamingAssessmentDisplay
    passages={passages}
    questionsContent={questionsContent}
    answerKeyContent={answerKeyContent}
    status={status}
    isStreaming={isStreaming}
    isQuestionsComplete={isQuestionsComplete}
  />
);

export default StreamingDisplay;
